module.exports = __webpack_public_path__ + "static/media/resultats_or2023.6c6bd9fd.jpg";